/* global AmCharts */

if (AmCharts.translations["export"]) {

    AmCharts.translations["export"]["en"] = {
        "fallback.save.text": "CTRL + C to copy the data into the clipboard.",
        "fallback.save.image": "Rightclick -> Save picture as... to save the image.",

        "capturing.delayed.menu.label": "{{duration}}",
        "capturing.delayed.menu.title": "Click to cancel",

        "menu.label.print": "Print",
        "menu.label.undo": "Undo",
        "menu.label.redo": "Redo",
        "menu.label.cancel": "Cancel",

        "menu.label.save.image": "Save image ...",
        "menu.label.save.data": "Download all ...",
        "menu.label.save.visible": "Download date range ...",

        "menu.label.draw": "Annotate ...",
        "menu.label.draw.change": "Change ...",
        "menu.label.draw.add": "Add ...",
        "menu.label.draw.shapes": "Shape ...",
        "menu.label.draw.colors": "Color ...",
        "menu.label.draw.widths": "Size ...",
        "menu.label.draw.opacities": "Opacity ...",
        "menu.label.draw.text": "Text",

        "menu.label.draw.modes": "Mode ...",
        "menu.label.draw.modes.pencil": "Pencil",
        "menu.label.draw.modes.line": "Line",
        "menu.label.draw.modes.arrow": "Arrow",

        "label.saved.from": "Saved from: "
    };

    AmCharts.translations["export"]["fr"] = {
        "fallback.save.text": "CTRL + C pour copier dans le presse-papier.",
        "fallback.save.image": "Clic-droit -> Enregistrer sous... pour sauvegarder l'image.",

        "capturing.delayed.menu.label": "{{duration}}",
        "capturing.delayed.menu.title": "Cliquez pour annuler",

        "menu.label.print": "Imprimer",
        "menu.label.undo": "Retour",
        "menu.label.redo": "Refaire",
        "menu.label.cancel": "Annuler",

        "menu.label.save.image": "Sauvegarder l’image ...",
        "menu.label.save.data": "Tout télécharger ...",
        "menu.label.save.visible": "Télécharger la période ...",

        "menu.label.draw": "Annoter ...",
        "menu.label.draw.change": "Changer le ...",
        "menu.label.draw.add": "Ajouter ...",
        "menu.label.draw.shapes": "Formes ...",
        "menu.label.draw.colors": "Couleurs ...",
        "menu.label.draw.widths": "Taille ...",
        "menu.label.draw.opacities": "Opacité ...",
        "menu.label.draw.text": "Texte",

        "menu.label.draw.modes": "Mode ...",
        "menu.label.draw.modes.pencil": "Crayon",
        "menu.label.draw.modes.line": "Ligne",
        "menu.label.draw.modes.arrow": "Flèche",

        "label.saved.from": "Sauvé de la: "
    };
}